import { createSlice } from "@reduxjs/toolkit"

export const ordersAnalyticsListSlice = createSlice({
	name: "ordersAnalytics",
	initialState: {
		ordersAnalytics: "",
		errors: [],
	},

	reducers: {
        getOrdersAnalytics: (state, action) => {
            // console.log(action.payload);
			state.ordersAnalytics = action.payload
		},
		getOrdersAnalyticsList: (state, action) => {
            
			state.ordersAnalytics = action.payload
		},
		getErrors: (state, action) => {
			state.errors = action.payload
		},
	},
})
export const {getOrdersAnalytics, getOrdersAnalyticsList, getErrors} = ordersAnalyticsListSlice.actions

export default ordersAnalyticsListSlice.reducer

